import React, { useEffect, useState } from "react";
import { X, CheckCircle2 } from "lucide-react";
import { shouldShowCelebration, dismissCelebration } from "@/lib/installPwa";

// Fixed-bottom strip shown for 7 days after the user adds FamFeel to their
// home screen. Dismissable — once dismissed, it stays hidden.

export default function InstallCelebrationBanner() {
  const [show, setShow] = useState(shouldShowCelebration());

  useEffect(() => {
    // Re-evaluate once on mount in case `shouldShowCelebration` changed
    // between render and effect (e.g. storage was just written).
    setShow(shouldShowCelebration());
    const onFocus = () => setShow(shouldShowCelebration());
    const onInstalled = () => setShow(shouldShowCelebration());
    window.addEventListener("focus", onFocus);
    window.addEventListener("famfeel:installed", onInstalled);
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("famfeel:installed", onInstalled);
    };
  }, []);

  if (!show) return null;

  const onDismiss = () => {
    dismissCelebration();
    setShow(false);
  };

  return (
    <div
      className="fixed bottom-3 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-24px)] max-w-md"
      data-testid="install-celebration"
    >
      <div className="flex items-start gap-3 rounded-[20px] border border-[color:var(--line)] bg-[color:var(--ink)] text-[color:var(--bg)] pl-4 pr-2 py-2.5 shadow-[0_6px_30px_-12px_rgba(0,0,0,0.5)]">
        <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={2} />
        <div className="text-[13px] leading-snug flex-1 min-w-0">
          Added to home screen — make sure all family members do the same for easy access.
        </div>
        <button
          onClick={onDismiss}
          className="w-7 h-7 rounded-full hover:bg-white/10 flex items-center justify-center flex-shrink-0 mt-0.5"
          data-testid="install-celebration-dismiss"
          aria-label="Dismiss"
        >
          <X className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
